import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { qualityKeys } from '@/shared/lib/query/queryKeys';

import { getTableQualityData, type TableQualityApiParams } from '@/entities/quality/api/getTableQualityData';

export const useTableQualityDataQuery = (params: TableQualityApiParams, enabled: boolean) => {
  return useQueryWithBoundary({
    queryKey: qualityKeys.tableQuality(params),
    queryFn: () => getTableQualityData(params),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
